<template>
  <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5BarCharts",

  data() {
    return {};
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts(gaugeValue) {
      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: `${gaugeValue}%`,
          subtext: '掌握率',
          left: 'center',
          top: '55%', //top待调整
          textStyle: {
            color: '#000',
            fontSize: 36,
            fontFamily: 'DINAlternate-Bold',
          },
          subtextStyle: {
            color: '#999',
            fontSize: 16,
            marginTop:"20px",
            fontFamily: 'PingFangSC-Regular',
            top: '70%'
          },
          itemGap: 10 //主副标题间距
        },
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 100,
            radius: "95%",
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 40,
                color: [
                  [0.20, "#4274FE"],
                  [0.40, "#A88BDF"],
                  [0.60, "#F9A162"],
                  [0.80, "#FD6A56"],
                  [1, "#FC5A55"],
                ],
              },
            },
            pointer: {
              width: 6,
              length: "30%",
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              show: false,
              length: 12,
              lineStyle: {
                color: "auto",
                width: 10,
              },
            },
            splitLine: {
              show: false,
              length: 20,
              lineStyle: {
                color: "auto",
                width: 5,
              },
            },
            axisLabel: {
              color: "#FFF",
              fontSize: 14,
              distance: -20,
              formatter: function (value) {
                if (value === 90) {
                  return "高";
                } else if (value === 73) {
                  return "较高";
                } else if (value === 50) {
                  return "适中";
                } else if (value === 27) {
                  return "较低";
                } else if (value === 10) {
                  return "低";
                }
              },
            },
            title: {
              offsetCenter: ["-20%", "10%"],
              fontSize: 20,
            },
            detail: {
              fontSize: 40,
              offsetCenter: ["30%", "10%"],
              valueAnimation: true,
              formatter: function (value) {
                return Math.round(value) + "分";
              },
              color: "#4D96FF",
              fontWeight: "bold",
            },
            data: [],
          },
          // 内部圆圈 - 添加阴影效果
          {
            type: "gauge",
            radius: "45%",
            center: ["50%", "66%"],
            min: 0,
            max: 100,
            startAngle: 180,
            endAngle: 0,
            axisLine: {
              show: true,
              lineStyle: {
                width: 120,
                color: [
                  [
                    1,
                    "#FFF"
                  ],
                ],
                // 添加阴影效果
                shadowBlur: 15,
                shadowColor: 'rgba(0, 0, 0, 0.3)',
                shadowOffsetX: 0,
                shadowOffsetY: 5
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: true,
              width: '30%',
              length: '150%',
              color: "#FB7B55",
            },
            detail: {
              fontSize: 40,
              offsetCenter: [0, "0%"],
              valueAnimation: true,
              formatter: function (value) {
                return value + "%";
              },
              color: "#333", // 改为深色提高可读性
              fontWeight: "bold",
            },
            data: [
              {
                name: '剩余天数',
                value: gaugeValue,
              },
            ],
          },
          // 添加一个额外的系列来增强阴影效果
          {
            type: "gauge",
            radius: "48%", // 比内表盘稍大一点
            center: ["50%", "66%"],
            min: 0,
            max: 100,
            startAngle: 360,
            endAngle: 0,
            axisLine: {
              show: true,
              lineStyle: {
                width: 130, // 稍宽一些
                color: [
                  [
                    1,
                    "#FFF" // 半透明黑色，用于增强阴影
                  ],
                ],
                shadowBlur: 20,
                shadowColor: 'rgba(0, 0, 0, 0.2)',
                shadowOffsetX: 0,
                shadowOffsetY: 8
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false, // 不显示指针
            },
            detail: {
              show: false, // 不显示详情
            },
            data: [
              {
                // value: 10,
                // name:"掌握率",
              },
            ],
          }
        ],
      };

      option && myChart.setOption(option);

      // 添加响应式处理
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.charts_el {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  // 为整个图表容器添加轻微背景渐变，使阴影效果更明显
  //   background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}
</style>